import '../App.css';
import './Home.css';
import { Link } from 'react-router-dom';
import Restaurant from '@mui/icons-material/Restaurant';
import LocalFireDepartment from '@mui/icons-material/LocalFireDepartment';
import FilterAlt from '@mui/icons-material/FilterAlt';
import FavoriteIcon from '@mui/icons-material/Favorite';
import BoltIcon from '@mui/icons-material/Bolt';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { TotalFoodsInDatabase } from '../App';

export default function Home() {
    return (
        <div className='home-page-redesign'>
            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">
                        Welcome to Valheim Cooking
                    </h1>
                    <p className="hero-subtitle">
                        Your ultimate companion for mastering the culinary arts in Valheim
                    </p>
                    <p className="hero-description">
                        Discover, filter, and plan your meals to maximize health, stamina, and eitr as you progress through the ten realms.
                    </p>
                    <div className="hero-buttons">
                        <Link to="/food-table" className="btn btn-primary">
                            <Restaurant /> Explore Food Table
                        </Link>
                        <Link to="/settings" className="btn btn-secondary">
                            <FilterAlt /> Configure Filters
                        </Link>
                    </div>
                </div>
                <div className="hero-image">
                    <img src={`${process.env.PUBLIC_URL}/images/Splash.png`} alt="Valheim Cooking" />
                </div>
            </section>

            {/* Stats Section */}
            <section className="stats-section">
                <div className="stat-card">
                    <div className="stat-icon">
                        <Restaurant />
                    </div>
                    <div className="stat-value">{TotalFoodsInDatabase || 0}</div>
                    <div className="stat-label">Food Items</div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon">
                        <LocalFireDepartment />
                    </div>
                    <div className="stat-value">9</div>
                    <div className="stat-label">Cooking Stations</div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon">
                        <FilterAlt />
                    </div>
                    <div className="stat-value">9</div>
                    <div className="stat-label">Biomes</div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features-section">
                <h2 className="section-title">Key Features</h2>
                <div className="features-grid">
                    <div className="feature-card">
                        <div className="feature-icon health-icon">
                            <FavoriteIcon fontSize="large" />
                        </div>
                        <h3>Health & Stamina</h3>
                        <p>
                            Track food stats for health, stamina, and eitr. Compare items to find the perfect balance for your playstyle.
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon stamina-icon">
                            <BoltIcon fontSize="large" />
                        </div>
                        <h3>Smart Filtering</h3>
                        <p>
                            Filter foods by biome progression, crafting stations, cauldron level, duration, and weight to match your current game state.
                        </p>
                    </div>
                    <div className="feature-card">
                        <div className="feature-icon eitr-icon">
                            <AutoAwesomeIcon fontSize="large" />
                        </div>
                        <h3>Progression Tracking</h3>
                        <p>
                            See which foods are available in your current biome and unlock new recipes as you explore further realms.
                        </p>
                    </div>
                </div>
            </section>

            {/* How to Use Section */}
            <section className="howto-section">
                <h2 className="section-title">How to Use</h2>
                <div className="howto-grid">
                    <div className="howto-step">
                        <div className="step-number">1</div>
                        <h3>Browse the Food Table</h3>
                        <p>
                            Visit the Food Table to view all available food items with their complete stats including health, stamina, eitr, healing rate, and duration.
                        </p>
                    </div>
                    <div className="howto-step">
                        <div className="step-number">2</div>
                        <h3>Set Your Filters</h3>
                        <p>
                            Use the Filters page to select which biomes you've unlocked and which cooking stations you have access to. The table will update to show only craftable foods.
                        </p>
                    </div>
                    <div className="howto-step">
                        <div className="step-number">3</div>
                        <h3>Advanced Options</h3>
                        <p>
                            Fine-tune your search with advanced filters like cauldron level, effect duration, and item weight to find the perfect foods for your adventure.
                        </p>
                    </div>
                    <div className="howto-step">
                        <div className="step-number">4</div>
                        <h3>Plan Your Meals</h3>
                        <p>
                            Click on any food item to see detailed information including required ingredients and crafting station details.
                        </p>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <h2>Ready to Start Cooking?</h2>
                <p>Explore our complete database of Valheim food items and optimize your survival strategy.</p>
                <Link to="/food-table" className="btn btn-large btn-primary">
                    <Restaurant /> View All Foods
                </Link>
            </section>
        </div>
    );
}
